// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  In this CSS file we write common styles for application and App.js file's style also
  Ex: We write responsive UI also in this css file.
*/

.welcometext,
.loadingblock {
  text-align: center;
  vertical-align: middle;
  font-size: 30px;
  padding-top: 15%;
}

#root {
  height: 100vh;
  overflow: hidden;
  font-family: var(--default-FontName);
  background-color: var(--appcontent-bg-layer-color);
}
.boApplication {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px 0px;
}
.boApplication.aira-layout {
  padding: 0px;
}
.boApplication.aira-layout .bodypage.nonnps {
  padding-bottom: 0px;
}
.boApplication.hide-title-bar .titleBar-root {
  display: none;
}
.boApplication.hide-title-bar {
  padding: 15px 0px;
}

.boApplication.hide-title-bar.report-submenu-layout .titleBar-root {
  display: grid;
  grid-template-columns: auto 1fr auto;
  padding: 0px 43px 0px 0px;
}

.boApplication.hide-title-bar.report-submenu-layout
  .titleBar-root
  .titleBar-Search,
.boApplication.hide-title-bar.report-submenu-layout .titleBar-root .userHeader {
  display: none;
}

body {
  overflow-y: hidden;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

body[data-theme='dark'] {
  --dark-panel-bg: #262d33;
  --dark-panel-surface: #303840;
  --dark-panel-surface-elevated: #2a333d;
  --dark-panel-hover: #374351;
  --dark-panel-border: #4f5d6d;
  --dark-panel-shadow: #151d26;
  --dark-panel-edge-bg: #1f2831;
  --dark-topbar-bg: #1f2a36;
  --dark-shell-border: #7d8ea2;
  /* --dark-search-bg: #2c3641; */
  --dark-search-bg: #262d33;
  --dark-search-border: #838383;
  --dark-search-text: #eaf1f8;
  --dark-search-placeholder: #9fb0c2;
  --dark-search-action-bg: #3f78c6;
  --dark-active-menu-bg: #3f78c6;
  --dark-active-menu-bg-hover: #4b86d6;
  --dark-text-primary: #eaf1f8;
  --dark-text-secondary: #c3cfdb;
  --dark-text-tertiary: #a7b7c8;
  --dark-avatar-bg: #3f78c6;
  --dark-notification-bg: #f2c94c;
  --dark-notification-text: #1a1f27;
  --dark-panels-border: #262d33;
  color: var(--dark-text-primary);
  background-color: var(--dark-panel-edge-bg);
}

.titlebar {
  height: 75px;
  width: 100%;
  background-color: var(--appcontent-bg-layer-color);
  display: flex;
  align-items: center;
  font-weight: var(--header-FontWeight);
}

.title {
  color: var(--default-FontColour);
  font-size: 20px;
  margin: 0px 0px 0px 30px !important;
}

.bodypage {
  background-color: var(--appcontent-bg-color);
  border-radius: 40px;
  /* height: 86%; */
  height: 100%;
  padding: 0.5%;
  overflow: hidden;
}

.bodypage.nonnps {
  border-radius: 0px;
  background-color: var(--whiteColour);
  height: 94%;
}

.body-data-page {
  /* width: 99.5%; */
  /* margin-left: 0.25%; */
  background-color: white;
  border-radius: 30px;
  height: 100%;
}

.body-data-page.nonnps {
  border-radius: 0px;
  background-color: unset;
}

.modalmainpage .searchmadaltitlebar .closeicon .MuiSvgIcon-root {
  font-size: 1.5rem;
}

/* for global confirmation Popup -- start */
.MuiDialog-root.MuiModal-root
  .MuiDialog-container.MuiDialog-scrollPaper
  .MuiPaper-root {
  width: fit-content;
  /* min-width: 25%; */
  padding: 25px;
  display: grid;
  grid-template-rows: auto;
  gap: 15px;
  border-radius: var(--dialogBorderRadius);
  font-family: var(--default-FontName);
  justify-items: stretch;
}

.MuiDialog-root.MuiModal-root
  .MuiDialog-container.MuiDialog-scrollPaper
  .MuiPaper-root
  .MuiDialogContent-root
  .MuiDialogContentText-root {
  font-size: var(--dialogContentFontSize);
  font-family: var(--default-FontName);
  color: var(--default-FontColour);
  font-weight: var(--dialogContentFontWeight);
}

.MuiDialog-root.MuiModal-root
  .MuiDialog-container.MuiDialog-scrollPaper
  .MuiPaper-root
  .MuiTypography-root,
.MuiDialog-root.MuiModal-root
  .MuiDialog-container.MuiDialog-scrollPaper
  .MuiPaper-root
  .MuiDialogContent-root,
.MuiDialog-root.MuiModal-root
  .MuiDialog-container.MuiDialog-scrollPaper
  .MuiPaper-root
  .MuiDialogActions-root
  .MuiButtonBase-root {
  padding: 0px;
}

.MuiDialog-root.MuiModal-root
  .MuiDialog-container.MuiDialog-scrollPaper
  .MuiPaper-root
  .MuiDialogActions-root {
  gap: 12px;
  padding: 0px;
  margin-top: 0px !important;
  margin-right: 0px !important;
  margin-bottom: 0px !important;
  margin-left: 0px !important;
}

.noTitle_CenterAlignedClass .MuiPaper-root {
  min-width: 24%;

  padding: 3.9vh 2.291vw !important;
  display: grid;
  grid-template-rows: auto;
  gap: 2.5vh !important;
  border-radius: var(--dialogBorderRadius);
}

.noTitle_CenterAlignedClass .MuiPaper-root .MuiDialogContent-root {
  display: flex;
  justify-content: center;
}

.noTitle_CenterAlignedClass .MuiDialogActions-root {
  gap: 12px;
  justify-content: center !important;
}

.noTitle_CenterAlignedClass .MuiDialogActions-root .button.MuiButton-root {
  border-radius: var(--buttonBorderRadius) !important;
}

/* for global confirmation Popup -- end */

/* UseConfirmation's design -- start */
.MuiPaper-root[aria-describedby='noTitle_CenterAligned']
  .MuiDialogActions-root {
  display: flex !important;
  justify-content: center !important;
}

.MuiPaper-root[aria-describedby='noTitle_CenterAligned'],
.MuiPaper-root[aria-describedby='noTitle_CenterAligned textAlignCentre'] {
  display: flex !important;
  align-items: center !important;
  padding: 3.9vh 2.291vw !important;
  gap: 2.5vh !important;
}

/* UseConfirmation's design -- end */

/* Change font size as per screen media*/
@media (min-width: 1850px) {
  body {
    --default-FontSize: 16px !important;
    --header-FontSize: 28px !important;
    --sub-header-FontSize: 24px !important;
    --label-FontSize: 16px !important;
    --heading-FontSize: 32px !important;
    --subHeading-FontSize: 21px !important;
    --mainheading-FontSize: 24px !important;
    --listHeader-FontSize: 12px !important;
    --additionalTabSideHead: 18px !important;
    --brandTitle: 14px !important;
    --avatarFontSize: 48px !important;
    --avatarIconSize: 26px !important;
    --listHeaderFontSize: 16px !important;
    /* contractCard */
    --contractCardTitleFontSize: 24px !important;
    --contractCardCountTitleFontSize: 19px !important;
    --contractCardCountFontSize: 24px !important;
    --contractCardLogoSize: 72px !important;
    --contractCardLogoHeight: 51.55px !important;
    --contractCardLogoWidth: 36px !important;
    /* contractCard */
    /* caseOverView - start */
    --gridTitleFontSize: 20px !important;
    --countValueFontSize: 32px !important;
    /* caseOverView - end */
    /* Tooltip - start */
    --tooltipFontSize: 14px !important;
    --fieldAlertFontSize: 14px !important;
    /* Tooltip - end */
    /* pcnHeaderFontSize -- start */
    --pcnHeaderFontSize: 18px !important;
    /* pcnHeaderFontSize -- end */
    --default-NotificationContentHeadingFontSize: 18px !important;
    /* accordionTitleFontSize -- start */
    --accordionTitleFontSize: 19px !important;
    /* accordionTitleFontSize -- end */
    /* ActionButton -- start */
    --ActionButtonTitleFontSize: 15px !important;
    --ActionButtonIconFontSize: 22px !important;
    --ActionButtonDescriptionFontSize: 14px !important;
    /* ActionButton -- end */
    /* ActionConfirmation -- start */
    --ActionConfirmationDataFontSize: 14px !important;
    /* ActionConfirmation -- end */
    /* Button -- start */
    --buttonHeight: 40px !important;
    /* Button -- end */
    /* DialogPopup -- start */
    --dialogIconFontSize: 16px !important;
    /* DialogPopup -- end */
  }
}

/* (-2) */
@media (min-width: 1600px) and (max-width: 1849px) {
  body {
    --default-FontSize: 14px !important;
    --header-FontSize: 26px !important;
    --sub-header-FontSize: 22px !important;
    --label-FontSize: 14px !important;
    --heading-FontSize: 30px !important;
    --subHeading-FontSize: 20px !important;
    --mainheading-FontSize: 22px !important;
    --listHeader-FontSize: 10px !important;
    --additionalTabSideHead: 16px !important;
    --brandTitle: 12px !important;
    --avatarFontSize: 46px !important;
    --avatarIconSize: 24px !important;
    --listHeaderFontSize: 14px !important;
    /* contractCard */
    --contractCardTitleFontSize: 22px !important;
    --contractCardCountTitleFontSize: 17px !important;
    --contractCardCountFontSize: 22px !important;
    --contractCardLogoSize: 72px !important;
    --contractCardLogoHeight: 51.55px !important;
    --contractCardLogoWidth: 36px !important;
    /* contractCard */
    /* caseOverView - start */
    --gridTitleFontSize: 18px !important;
    --countValueFontSize: 30px !important;
    /* caseOverView - end */
    /* Tooltip - start */
    --tooltipFontSize: 12px !important;
    --fieldAlertFontSize: 12px !important;

    /* Tooltip - end */
    /* pcnHeaderFontSize -- start */
    --pcnHeaderFontSize: 16px !important;
    /* pcnHeaderFontSize -- end */
    --default-NotificationContentHeadingFontSize: 16px !important;
    /* accordionTitleFontSize -- start */
    --accordionTitleFontSize: 17px !important;
    /* accordionTitleFontSize -- end */
    /* ActionButton -- start */
    --ActionButtonTitleFontSize: 13px !important;
    --ActionButtonIconFontSize: 20px !important;
    --ActionButtonDescriptionFontSize: 12px !important;
    /* ActionButton -- end */
    /* ActionConfirmation -- start */
    --ActionConfirmationDataFontSize: 12px !important;
    /* ActionConfirmation -- end */
    /* Button -- start */
    --buttonHeight: 38px !important;
    /* Button -- end */
    /* DialogPopup -- start */
    --dialogIconFontSize: 14px !important;
    /* DialogPopup -- end */
  }
}

/* (-2) */
@media (min-width: 1366px) and (max-width: 1599px) {
  body {
    --default-FontSize: 12px !important;
    --header-FontSize: 24px !important;
    --sub-header-FontSize: 20px !important;
    --label-FontSize: 12px !important;
    --heading-FontSize: 28px !important;
    --subHeading-FontSize: 18px !important;
    --mainheading-FontSize: 20px !important;
    --listHeader-FontSize: 8px !important;
    --additionalTabSideHead: 14px !important;
    --brandTitle: 10px !important;
    --avatarFontSize: 44px !important;
    --avatarIconSize: 22px !important;
    --listHeaderFontSize: 12px !important;
    /* contractCard */
    --contractCardTitleFontSize: 20px !important;
    --contractCardCountTitleFontSize: 15px !important;
    --contractCardCountFontSize: 20px !important;
    --contractCardLogoSize: 50px !important;
    --contractCardLogoHeight: 35px !important;
    --contractCardLogoWidth: 25px !important;
    /* contractCard */
    /* caseOverView - start */
    --gridTitleFontSize: 16px !important;
    --countValueFontSize: 28px !important;
    /* caseOverView - end */
    /* Tooltip - start */
    /* maintaining 12 instead of (-2) due to (-2) results less than 12(standard font size)*/
    --tooltipFontSize: 12px !important;
    --fieldAlertFontSize: 12px !important;
    /* Tooltip - end */
    /* pcnHeaderFontSize -- start */
    --pcnHeaderFontSize: 14px !important;
    /* pcnHeaderFontSize -- end */
    --default-NotificationContentHeadingFontSize: 14px !important;
    /* accordionTitleFontSize -- start */
    --accordionTitleFontSize: 15px !important;
    /* accordionTitleFontSize -- end */
    /* ActionButton -- start */
    --ActionButtonTitleFontSize: 12px !important;
    --ActionButtonIconFontSize: 18px !important;
    --ActionButtonDescriptionFontSize: 12px !important;
    /* ActionButton -- end */
    /* ActionConfirmation -- start */
    --ActionConfirmationDataFontSize: 12px !important;
    /* ActionConfirmation -- end */
    /* Button -- start */
    --buttonHeight: 36px !important;
    /* Button -- end */
    /* DialogPopup -- start */
    --dialogIconFontSize: 12px !important;
    /* DialogPopup -- end */
  }
}

/* (+1) */
@media (min-width: 1024px) and (max-width: 1365px) {
  body {
    --default-FontSize: 13px !important;
    --header-FontSize: 25px !important;
    --sub-header-FontSize: 21px !important;
    --label-FontSize: 13px !important;
    --heading-FontSize: 29px !important;
    --subHeading-FontSize: 19px !important;
    --mainheading-FontSize: 21px !important;
    --listHeader-FontSize: 9px !important;
    --additionalTabSideHead: 15px !important;
    --brandTitle: 11px !important;
    --avatarFontSize: 45px !important;
    --avatarIconSize: 23px !important;
    --listHeaderFontSize: 13px !important;
    /* contractCard */
    --contractCardTitleFontSize: 21px !important;
    --contractCardCountTitleFontSize: 16px !important;
    --contractCardCountFontSize: 21px !important;
    --contractCardLogoSize: 50px !important;
    --contractCardLogoHeight: 30px !important;
    --contractCardLogoWidth: 25px !important;
    /* contractCard */
    /* caseOverView - start */
    --gridTitleFontSize: 17px !important;
    --countValueFontSize: 29px !important;
    /* caseOverView - end */
    /* maintaining 12 instead of usual due to usual results less than 12(standard font size)*/
    --tooltipFontSize: 12px !important;
    --fieldAlertFontSize: 11px !important;
    /* Tooltip - end */
    /* pcnHeaderFontSize -- start */
    --pcnHeaderFontSize: 15px !important;
    /* pcnHeaderFontSize -- end */
    --default-NotificationContentHeadingFontSize: 15px !important;
    /* accordionTitleFontSize -- start */
    --accordionTitleFontSize: 16px !important;
    /* accordionTitleFontSize -- end */
    /* ActionButton -- start */
    --ActionButtonTitleFontSize: 12px !important;
    --ActionButtonIconFontSize: 16px !important;
    --ActionButtonDescriptionFontSize: 12px !important;
    /* ActionButton -- end */
    /* ActionConfirmation -- start */
    --ActionConfirmationDataFontSize: 12px !important;
    /* ActionConfirmation -- end */
    /* Button -- start */
    --buttonHeight: 34px !important;
    /* Button -- end */
    /* DialogPopup -- start */
    --dialogIconFontSize: 12px !important;
    /* DialogPopup -- end */
  }
}

.report-style-class {
  width: 100%;
}

div#powerbireport {
  display: flex;
  /* height: 100%; */
  /* width: 100%; */
  flex-direction: row;
  height: 98%;
  /* padding: 16px 10px 11px 0px; */
}

@media (min-width: 491px) and (max-width: 1024px) {
}

@media (min-width: 1025px) and (max-width: 1360px) {
  .bodypage {
    height: 100%;
  }
  .drawer.drawer_open ~ .bodypage.nonnps {
    width: calc(96.5% - 205px) !important;
    height: 100% !important;
  }

  .drawer.drawer_close ~ .bodypage.nonnps {
    width: 96% !important;
    height: 100% !important;
  }
}

@media (min-width: 1361px) and (max-width: 1536px) {
  /* .bodypage {
    height: 90% !important;
  } */
  /* commented for reference */

  .drawer.drawer_open ~ .bodypage.nonnps {
    width: calc(96.5% - 197px) !important;
    height: 100% !important;
  }

  .drawer.drawer_close ~ .bodypage.nonnps {
    width: 96.5% !important;
    height: 100% !important;
  }
}

@media (min-width: 1537px) and (max-width: 1600px) {
  /*  .bodypage {
    height: 90%;
  } */
  /* commented for reference */

  .drawer.drawer_close ~ .bodypage.nonnps {
    width: 96.5% !important;
    height: 100%;
  }

  .drawer.drawer_open ~ .bodypage.nonnps {
    width: calc(96.5% - 197px);
    height: 100%;
  }
}

@media (max-width: 1024px) {
  .bodypage {
    height: 90%;
  }

  .drawer.drawer_close ~ .bodypage.nonnps {
    width: 94.5% !important;
    height: 100%;
  }

  .drawer.drawer_open ~ .bodypage.nonnps {
    width: calc(96.5% - 217px);
    height: 100%;
  }
}

.gridData .gridContainer .MuiDataGrid-root .MuiDataGrid-footerContainer {
  background-color: var(--whiteColour);
}

/* ── preCaseAllocation page tokens ──────────────────────────── */
body {
  --pa-page-padding: 32px 24px;
  --pa-icon-size: 18px;
  --pa-hover-overlay: rgba(0, 0, 0, 0.06);
  --pa-selection-bg-color: #f0f8fb;
  --pa-selection-border-color: rgba(50, 118, 207, 0.25);
  --pa-btn-hover-bg: rgba(50, 118, 207, 0.06);
  --pa-assign-container-width: 500px;
  --pa-warning-bg-color: #fff8e1;
  --pa-warning-border-color: #ffb300;
  --pa-warning-icon-color: #f57c00;
}
`, "",{"version":3,"sources":["webpack://./src/app/App.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;;;CAGC;;AAED;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,kDAAkD;AACpD;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,sCAAsC;EACtC,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,kCAAkC;EAClC,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;EAC/B,iCAAiC;EACjC,6BAA6B;EAC7B,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;;;EAGE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,aAAa;EACb,wBAAwB;EACxB,SAAS;EACT,wCAAwC;EACxC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;;;;EAKE,uCAAuC;EACvC,oCAAoC;EACpC,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;;;;;;;;;;;;;EAaE,YAAY;AACd;;AAEA;;;;EAIE,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;;EAEd,iCAAiC;EACjC,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,mDAAmD;AACrD;;AAEA,yCAAyC;;AAEzC,sCAAsC;AACtC;;EAEE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA,oCAAoC;;AAEpC,wCAAwC;AACxC;EACE;IACE,mCAAmC;IACnC,kCAAkC;IAClC,sCAAsC;IACtC,iCAAiC;IACjC,mCAAmC;IACnC,sCAAsC;IACtC,uCAAuC;IACvC,sCAAsC;IACtC,wCAAwC;IACxC,6BAA6B;IAC7B,iCAAiC;IACjC,iCAAiC;IACjC,qCAAqC;IACrC,iBAAiB;IACjB,4CAA4C;IAC5C,iDAAiD;IACjD,4CAA4C;IAC5C,uCAAuC;IACvC,4CAA4C;IAC5C,wCAAwC;IACxC,iBAAiB;IACjB,yBAAyB;IACzB,oCAAoC;IACpC,qCAAqC;IACrC,uBAAuB;IACvB,oBAAoB;IACpB,kCAAkC;IAClC,qCAAqC;IACrC,kBAAkB;IAClB,+BAA+B;IAC/B,oCAAoC;IACpC,6BAA6B;IAC7B,6DAA6D;IAC7D,oCAAoC;IACpC,yCAAyC;IACzC,kCAAkC;IAClC,0BAA0B;IAC1B,4CAA4C;IAC5C,2CAA2C;IAC3C,kDAAkD;IAClD,wBAAwB;IACxB,gCAAgC;IAChC,iDAAiD;IACjD,8BAA8B;IAC9B,oBAAoB;IACpB,+BAA+B;IAC/B,kBAAkB;IAClB,yBAAyB;IACzB,qCAAqC;IACrC,uBAAuB;EACzB;AACF;;AAEA,SAAS;AACT;EACE;IACE,mCAAmC;IACnC,kCAAkC;IAClC,sCAAsC;IACtC,iCAAiC;IACjC,mCAAmC;IACnC,sCAAsC;IACtC,uCAAuC;IACvC,sCAAsC;IACtC,wCAAwC;IACxC,6BAA6B;IAC7B,iCAAiC;IACjC,iCAAiC;IACjC,qCAAqC;IACrC,iBAAiB;IACjB,4CAA4C;IAC5C,iDAAiD;IACjD,4CAA4C;IAC5C,uCAAuC;IACvC,4CAA4C;IAC5C,wCAAwC;IACxC,iBAAiB;IACjB,yBAAyB;IACzB,oCAAoC;IACpC,qCAAqC;IACrC,uBAAuB;IACvB,oBAAoB;IACpB,kCAAkC;IAClC,qCAAqC;;IAErC,kBAAkB;IAClB,+BAA+B;IAC/B,oCAAoC;IACpC,6BAA6B;IAC7B,6DAA6D;IAC7D,oCAAoC;IACpC,yCAAyC;IACzC,kCAAkC;IAClC,0BAA0B;IAC1B,4CAA4C;IAC5C,2CAA2C;IAC3C,kDAAkD;IAClD,wBAAwB;IACxB,gCAAgC;IAChC,iDAAiD;IACjD,8BAA8B;IAC9B,oBAAoB;IACpB,+BAA+B;IAC/B,kBAAkB;IAClB,yBAAyB;IACzB,qCAAqC;IACrC,uBAAuB;EACzB;AACF;;AAEA,SAAS;AACT;EACE;IACE,mCAAmC;IACnC,kCAAkC;IAClC,sCAAsC;IACtC,iCAAiC;IACjC,mCAAmC;IACnC,sCAAsC;IACtC,uCAAuC;IACvC,qCAAqC;IACrC,wCAAwC;IACxC,6BAA6B;IAC7B,iCAAiC;IACjC,iCAAiC;IACjC,qCAAqC;IACrC,iBAAiB;IACjB,4CAA4C;IAC5C,iDAAiD;IACjD,4CAA4C;IAC5C,uCAAuC;IACvC,yCAAyC;IACzC,wCAAwC;IACxC,iBAAiB;IACjB,yBAAyB;IACzB,oCAAoC;IACpC,qCAAqC;IACrC,uBAAuB;IACvB,oBAAoB;IACpB,uFAAuF;IACvF,kCAAkC;IAClC,qCAAqC;IACrC,kBAAkB;IAClB,+BAA+B;IAC/B,oCAAoC;IACpC,6BAA6B;IAC7B,6DAA6D;IAC7D,oCAAoC;IACpC,yCAAyC;IACzC,kCAAkC;IAClC,0BAA0B;IAC1B,4CAA4C;IAC5C,2CAA2C;IAC3C,kDAAkD;IAClD,wBAAwB;IACxB,gCAAgC;IAChC,iDAAiD;IACjD,8BAA8B;IAC9B,oBAAoB;IACpB,+BAA+B;IAC/B,kBAAkB;IAClB,yBAAyB;IACzB,qCAAqC;IACrC,uBAAuB;EACzB;AACF;;AAEA,SAAS;AACT;EACE;IACE,mCAAmC;IACnC,kCAAkC;IAClC,sCAAsC;IACtC,iCAAiC;IACjC,mCAAmC;IACnC,sCAAsC;IACtC,uCAAuC;IACvC,qCAAqC;IACrC,wCAAwC;IACxC,6BAA6B;IAC7B,iCAAiC;IACjC,iCAAiC;IACjC,qCAAqC;IACrC,iBAAiB;IACjB,4CAA4C;IAC5C,iDAAiD;IACjD,4CAA4C;IAC5C,uCAAuC;IACvC,yCAAyC;IACzC,wCAAwC;IACxC,iBAAiB;IACjB,yBAAyB;IACzB,oCAAoC;IACpC,qCAAqC;IACrC,uBAAuB;IACvB,yFAAyF;IACzF,kCAAkC;IAClC,qCAAqC;IACrC,kBAAkB;IAClB,+BAA+B;IAC/B,oCAAoC;IACpC,6BAA6B;IAC7B,6DAA6D;IAC7D,oCAAoC;IACpC,yCAAyC;IACzC,kCAAkC;IAClC,0BAA0B;IAC1B,4CAA4C;IAC5C,2CAA2C;IAC3C,kDAAkD;IAClD,wBAAwB;IACxB,gCAAgC;IAChC,iDAAiD;IACjD,8BAA8B;IAC9B,oBAAoB;IACpB,+BAA+B;IAC/B,kBAAkB;IAClB,yBAAyB;IACzB,qCAAqC;IACrC,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iCAAiC;AACnC;;AAEA;AACA;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE;;KAEG;EACH,4BAA4B;;EAE5B;IACE,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;AACF;;AAEA;EACE;;KAEG;EACH,4BAA4B;;EAE5B;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kEAAkE;AAClE;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,uCAAuC;EACvC,gCAAgC;EAChC,qDAAqD;EACrD,2CAA2C;EAC3C,kCAAkC;EAClC,8BAA8B;EAC9B,kCAAkC;EAClC,gCAAgC;AAClC","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n/*\n  In this CSS file we write common styles for application and App.js file's style also\n  Ex: We write responsive UI also in this css file.\n*/\n\n.welcometext,\n.loadingblock {\n  text-align: center;\n  vertical-align: middle;\n  font-size: 30px;\n  padding-top: 15%;\n}\n\n#root {\n  height: 100vh;\n  overflow: hidden;\n  font-family: var(--default-FontName);\n  background-color: var(--appcontent-bg-layer-color);\n}\n.boApplication {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 24px 0px;\n}\n.boApplication.aira-layout {\n  padding: 0px;\n}\n.boApplication.aira-layout .bodypage.nonnps {\n  padding-bottom: 0px;\n}\n.boApplication.hide-title-bar .titleBar-root {\n  display: none;\n}\n.boApplication.hide-title-bar {\n  padding: 15px 0px;\n}\n\n.boApplication.hide-title-bar.report-submenu-layout .titleBar-root {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  padding: 0px 43px 0px 0px;\n}\n\n.boApplication.hide-title-bar.report-submenu-layout\n  .titleBar-root\n  .titleBar-Search,\n.boApplication.hide-title-bar.report-submenu-layout .titleBar-root .userHeader {\n  display: none;\n}\n\nbody {\n  overflow-y: hidden;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n}\n\nbody[data-theme='dark'] {\n  --dark-panel-bg: #262d33;\n  --dark-panel-surface: #303840;\n  --dark-panel-surface-elevated: #2a333d;\n  --dark-panel-hover: #374351;\n  --dark-panel-border: #4f5d6d;\n  --dark-panel-shadow: #151d26;\n  --dark-panel-edge-bg: #1f2831;\n  --dark-topbar-bg: #1f2a36;\n  --dark-shell-border: #7d8ea2;\n  /* --dark-search-bg: #2c3641; */\n  --dark-search-bg: #262d33;\n  --dark-search-border: #838383;\n  --dark-search-text: #eaf1f8;\n  --dark-search-placeholder: #9fb0c2;\n  --dark-search-action-bg: #3f78c6;\n  --dark-active-menu-bg: #3f78c6;\n  --dark-active-menu-bg-hover: #4b86d6;\n  --dark-text-primary: #eaf1f8;\n  --dark-text-secondary: #c3cfdb;\n  --dark-text-tertiary: #a7b7c8;\n  --dark-avatar-bg: #3f78c6;\n  --dark-notification-bg: #f2c94c;\n  --dark-notification-text: #1a1f27;\n  --dark-panels-border: #262d33;\n  color: var(--dark-text-primary);\n  background-color: var(--dark-panel-edge-bg);\n}\n\n.titlebar {\n  height: 75px;\n  width: 100%;\n  background-color: var(--appcontent-bg-layer-color);\n  display: flex;\n  align-items: center;\n  font-weight: var(--header-FontWeight);\n}\n\n.title {\n  color: var(--default-FontColour);\n  font-size: 20px;\n  margin: 0px 0px 0px 30px !important;\n}\n\n.bodypage {\n  background-color: var(--appcontent-bg-color);\n  border-radius: 40px;\n  /* height: 86%; */\n  height: 100%;\n  padding: 0.5%;\n  overflow: hidden;\n}\n\n.bodypage.nonnps {\n  border-radius: 0px;\n  background-color: var(--whiteColour);\n  height: 94%;\n}\n\n.body-data-page {\n  /* width: 99.5%; */\n  /* margin-left: 0.25%; */\n  background-color: white;\n  border-radius: 30px;\n  height: 100%;\n}\n\n.body-data-page.nonnps {\n  border-radius: 0px;\n  background-color: unset;\n}\n\n.modalmainpage .searchmadaltitlebar .closeicon .MuiSvgIcon-root {\n  font-size: 1.5rem;\n}\n\n/* for global confirmation Popup -- start */\n.MuiDialog-root.MuiModal-root\n  .MuiDialog-container.MuiDialog-scrollPaper\n  .MuiPaper-root {\n  width: fit-content;\n  /* min-width: 25%; */\n  padding: 25px;\n  display: grid;\n  grid-template-rows: auto;\n  gap: 15px;\n  border-radius: var(--dialogBorderRadius);\n  font-family: var(--default-FontName);\n  justify-items: stretch;\n}\n\n.MuiDialog-root.MuiModal-root\n  .MuiDialog-container.MuiDialog-scrollPaper\n  .MuiPaper-root\n  .MuiDialogContent-root\n  .MuiDialogContentText-root {\n  font-size: var(--dialogContentFontSize);\n  font-family: var(--default-FontName);\n  color: var(--default-FontColour);\n  font-weight: var(--dialogContentFontWeight);\n}\n\n.MuiDialog-root.MuiModal-root\n  .MuiDialog-container.MuiDialog-scrollPaper\n  .MuiPaper-root\n  .MuiTypography-root,\n.MuiDialog-root.MuiModal-root\n  .MuiDialog-container.MuiDialog-scrollPaper\n  .MuiPaper-root\n  .MuiDialogContent-root,\n.MuiDialog-root.MuiModal-root\n  .MuiDialog-container.MuiDialog-scrollPaper\n  .MuiPaper-root\n  .MuiDialogActions-root\n  .MuiButtonBase-root {\n  padding: 0px;\n}\n\n.MuiDialog-root.MuiModal-root\n  .MuiDialog-container.MuiDialog-scrollPaper\n  .MuiPaper-root\n  .MuiDialogActions-root {\n  gap: 12px;\n  padding: 0px;\n  margin-top: 0px !important;\n  margin-right: 0px !important;\n  margin-bottom: 0px !important;\n  margin-left: 0px !important;\n}\n\n.noTitle_CenterAlignedClass .MuiPaper-root {\n  min-width: 24%;\n\n  padding: 3.9vh 2.291vw !important;\n  display: grid;\n  grid-template-rows: auto;\n  gap: 2.5vh !important;\n  border-radius: var(--dialogBorderRadius);\n}\n\n.noTitle_CenterAlignedClass .MuiPaper-root .MuiDialogContent-root {\n  display: flex;\n  justify-content: center;\n}\n\n.noTitle_CenterAlignedClass .MuiDialogActions-root {\n  gap: 12px;\n  justify-content: center !important;\n}\n\n.noTitle_CenterAlignedClass .MuiDialogActions-root .button.MuiButton-root {\n  border-radius: var(--buttonBorderRadius) !important;\n}\n\n/* for global confirmation Popup -- end */\n\n/* UseConfirmation's design -- start */\n.MuiPaper-root[aria-describedby='noTitle_CenterAligned']\n  .MuiDialogActions-root {\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.MuiPaper-root[aria-describedby='noTitle_CenterAligned'],\n.MuiPaper-root[aria-describedby='noTitle_CenterAligned textAlignCentre'] {\n  display: flex !important;\n  align-items: center !important;\n  padding: 3.9vh 2.291vw !important;\n  gap: 2.5vh !important;\n}\n\n/* UseConfirmation's design -- end */\n\n/* Change font size as per screen media*/\n@media (min-width: 1850px) {\n  body {\n    --default-FontSize: 16px !important;\n    --header-FontSize: 28px !important;\n    --sub-header-FontSize: 24px !important;\n    --label-FontSize: 16px !important;\n    --heading-FontSize: 32px !important;\n    --subHeading-FontSize: 21px !important;\n    --mainheading-FontSize: 24px !important;\n    --listHeader-FontSize: 12px !important;\n    --additionalTabSideHead: 18px !important;\n    --brandTitle: 14px !important;\n    --avatarFontSize: 48px !important;\n    --avatarIconSize: 26px !important;\n    --listHeaderFontSize: 16px !important;\n    /* contractCard */\n    --contractCardTitleFontSize: 24px !important;\n    --contractCardCountTitleFontSize: 19px !important;\n    --contractCardCountFontSize: 24px !important;\n    --contractCardLogoSize: 72px !important;\n    --contractCardLogoHeight: 51.55px !important;\n    --contractCardLogoWidth: 36px !important;\n    /* contractCard */\n    /* caseOverView - start */\n    --gridTitleFontSize: 20px !important;\n    --countValueFontSize: 32px !important;\n    /* caseOverView - end */\n    /* Tooltip - start */\n    --tooltipFontSize: 14px !important;\n    --fieldAlertFontSize: 14px !important;\n    /* Tooltip - end */\n    /* pcnHeaderFontSize -- start */\n    --pcnHeaderFontSize: 18px !important;\n    /* pcnHeaderFontSize -- end */\n    --default-NotificationContentHeadingFontSize: 18px !important;\n    /* accordionTitleFontSize -- start */\n    --accordionTitleFontSize: 19px !important;\n    /* accordionTitleFontSize -- end */\n    /* ActionButton -- start */\n    --ActionButtonTitleFontSize: 15px !important;\n    --ActionButtonIconFontSize: 22px !important;\n    --ActionButtonDescriptionFontSize: 14px !important;\n    /* ActionButton -- end */\n    /* ActionConfirmation -- start */\n    --ActionConfirmationDataFontSize: 14px !important;\n    /* ActionConfirmation -- end */\n    /* Button -- start */\n    --buttonHeight: 40px !important;\n    /* Button -- end */\n    /* DialogPopup -- start */\n    --dialogIconFontSize: 16px !important;\n    /* DialogPopup -- end */\n  }\n}\n\n/* (-2) */\n@media (min-width: 1600px) and (max-width: 1849px) {\n  body {\n    --default-FontSize: 14px !important;\n    --header-FontSize: 26px !important;\n    --sub-header-FontSize: 22px !important;\n    --label-FontSize: 14px !important;\n    --heading-FontSize: 30px !important;\n    --subHeading-FontSize: 20px !important;\n    --mainheading-FontSize: 22px !important;\n    --listHeader-FontSize: 10px !important;\n    --additionalTabSideHead: 16px !important;\n    --brandTitle: 12px !important;\n    --avatarFontSize: 46px !important;\n    --avatarIconSize: 24px !important;\n    --listHeaderFontSize: 14px !important;\n    /* contractCard */\n    --contractCardTitleFontSize: 22px !important;\n    --contractCardCountTitleFontSize: 17px !important;\n    --contractCardCountFontSize: 22px !important;\n    --contractCardLogoSize: 72px !important;\n    --contractCardLogoHeight: 51.55px !important;\n    --contractCardLogoWidth: 36px !important;\n    /* contractCard */\n    /* caseOverView - start */\n    --gridTitleFontSize: 18px !important;\n    --countValueFontSize: 30px !important;\n    /* caseOverView - end */\n    /* Tooltip - start */\n    --tooltipFontSize: 12px !important;\n    --fieldAlertFontSize: 12px !important;\n\n    /* Tooltip - end */\n    /* pcnHeaderFontSize -- start */\n    --pcnHeaderFontSize: 16px !important;\n    /* pcnHeaderFontSize -- end */\n    --default-NotificationContentHeadingFontSize: 16px !important;\n    /* accordionTitleFontSize -- start */\n    --accordionTitleFontSize: 17px !important;\n    /* accordionTitleFontSize -- end */\n    /* ActionButton -- start */\n    --ActionButtonTitleFontSize: 13px !important;\n    --ActionButtonIconFontSize: 20px !important;\n    --ActionButtonDescriptionFontSize: 12px !important;\n    /* ActionButton -- end */\n    /* ActionConfirmation -- start */\n    --ActionConfirmationDataFontSize: 12px !important;\n    /* ActionConfirmation -- end */\n    /* Button -- start */\n    --buttonHeight: 38px !important;\n    /* Button -- end */\n    /* DialogPopup -- start */\n    --dialogIconFontSize: 14px !important;\n    /* DialogPopup -- end */\n  }\n}\n\n/* (-2) */\n@media (min-width: 1366px) and (max-width: 1599px) {\n  body {\n    --default-FontSize: 12px !important;\n    --header-FontSize: 24px !important;\n    --sub-header-FontSize: 20px !important;\n    --label-FontSize: 12px !important;\n    --heading-FontSize: 28px !important;\n    --subHeading-FontSize: 18px !important;\n    --mainheading-FontSize: 20px !important;\n    --listHeader-FontSize: 8px !important;\n    --additionalTabSideHead: 14px !important;\n    --brandTitle: 10px !important;\n    --avatarFontSize: 44px !important;\n    --avatarIconSize: 22px !important;\n    --listHeaderFontSize: 12px !important;\n    /* contractCard */\n    --contractCardTitleFontSize: 20px !important;\n    --contractCardCountTitleFontSize: 15px !important;\n    --contractCardCountFontSize: 20px !important;\n    --contractCardLogoSize: 50px !important;\n    --contractCardLogoHeight: 35px !important;\n    --contractCardLogoWidth: 25px !important;\n    /* contractCard */\n    /* caseOverView - start */\n    --gridTitleFontSize: 16px !important;\n    --countValueFontSize: 28px !important;\n    /* caseOverView - end */\n    /* Tooltip - start */\n    /* maintaining 12 instead of (-2) due to (-2) results less than 12(standard font size)*/\n    --tooltipFontSize: 12px !important;\n    --fieldAlertFontSize: 12px !important;\n    /* Tooltip - end */\n    /* pcnHeaderFontSize -- start */\n    --pcnHeaderFontSize: 14px !important;\n    /* pcnHeaderFontSize -- end */\n    --default-NotificationContentHeadingFontSize: 14px !important;\n    /* accordionTitleFontSize -- start */\n    --accordionTitleFontSize: 15px !important;\n    /* accordionTitleFontSize -- end */\n    /* ActionButton -- start */\n    --ActionButtonTitleFontSize: 12px !important;\n    --ActionButtonIconFontSize: 18px !important;\n    --ActionButtonDescriptionFontSize: 12px !important;\n    /* ActionButton -- end */\n    /* ActionConfirmation -- start */\n    --ActionConfirmationDataFontSize: 12px !important;\n    /* ActionConfirmation -- end */\n    /* Button -- start */\n    --buttonHeight: 36px !important;\n    /* Button -- end */\n    /* DialogPopup -- start */\n    --dialogIconFontSize: 12px !important;\n    /* DialogPopup -- end */\n  }\n}\n\n/* (+1) */\n@media (min-width: 1024px) and (max-width: 1365px) {\n  body {\n    --default-FontSize: 13px !important;\n    --header-FontSize: 25px !important;\n    --sub-header-FontSize: 21px !important;\n    --label-FontSize: 13px !important;\n    --heading-FontSize: 29px !important;\n    --subHeading-FontSize: 19px !important;\n    --mainheading-FontSize: 21px !important;\n    --listHeader-FontSize: 9px !important;\n    --additionalTabSideHead: 15px !important;\n    --brandTitle: 11px !important;\n    --avatarFontSize: 45px !important;\n    --avatarIconSize: 23px !important;\n    --listHeaderFontSize: 13px !important;\n    /* contractCard */\n    --contractCardTitleFontSize: 21px !important;\n    --contractCardCountTitleFontSize: 16px !important;\n    --contractCardCountFontSize: 21px !important;\n    --contractCardLogoSize: 50px !important;\n    --contractCardLogoHeight: 30px !important;\n    --contractCardLogoWidth: 25px !important;\n    /* contractCard */\n    /* caseOverView - start */\n    --gridTitleFontSize: 17px !important;\n    --countValueFontSize: 29px !important;\n    /* caseOverView - end */\n    /* maintaining 12 instead of usual due to usual results less than 12(standard font size)*/\n    --tooltipFontSize: 12px !important;\n    --fieldAlertFontSize: 11px !important;\n    /* Tooltip - end */\n    /* pcnHeaderFontSize -- start */\n    --pcnHeaderFontSize: 15px !important;\n    /* pcnHeaderFontSize -- end */\n    --default-NotificationContentHeadingFontSize: 15px !important;\n    /* accordionTitleFontSize -- start */\n    --accordionTitleFontSize: 16px !important;\n    /* accordionTitleFontSize -- end */\n    /* ActionButton -- start */\n    --ActionButtonTitleFontSize: 12px !important;\n    --ActionButtonIconFontSize: 16px !important;\n    --ActionButtonDescriptionFontSize: 12px !important;\n    /* ActionButton -- end */\n    /* ActionConfirmation -- start */\n    --ActionConfirmationDataFontSize: 12px !important;\n    /* ActionConfirmation -- end */\n    /* Button -- start */\n    --buttonHeight: 34px !important;\n    /* Button -- end */\n    /* DialogPopup -- start */\n    --dialogIconFontSize: 12px !important;\n    /* DialogPopup -- end */\n  }\n}\n\n.report-style-class {\n  width: 100%;\n}\n\ndiv#powerbireport {\n  display: flex;\n  /* height: 100%; */\n  /* width: 100%; */\n  flex-direction: row;\n  height: 98%;\n  /* padding: 16px 10px 11px 0px; */\n}\n\n@media (min-width: 491px) and (max-width: 1024px) {\n}\n\n@media (min-width: 1025px) and (max-width: 1360px) {\n  .bodypage {\n    height: 100%;\n  }\n  .drawer.drawer_open ~ .bodypage.nonnps {\n    width: calc(96.5% - 205px) !important;\n    height: 100% !important;\n  }\n\n  .drawer.drawer_close ~ .bodypage.nonnps {\n    width: 96% !important;\n    height: 100% !important;\n  }\n}\n\n@media (min-width: 1361px) and (max-width: 1536px) {\n  /* .bodypage {\n    height: 90% !important;\n  } */\n  /* commented for reference */\n\n  .drawer.drawer_open ~ .bodypage.nonnps {\n    width: calc(96.5% - 197px) !important;\n    height: 100% !important;\n  }\n\n  .drawer.drawer_close ~ .bodypage.nonnps {\n    width: 96.5% !important;\n    height: 100% !important;\n  }\n}\n\n@media (min-width: 1537px) and (max-width: 1600px) {\n  /*  .bodypage {\n    height: 90%;\n  } */\n  /* commented for reference */\n\n  .drawer.drawer_close ~ .bodypage.nonnps {\n    width: 96.5% !important;\n    height: 100%;\n  }\n\n  .drawer.drawer_open ~ .bodypage.nonnps {\n    width: calc(96.5% - 197px);\n    height: 100%;\n  }\n}\n\n@media (max-width: 1024px) {\n  .bodypage {\n    height: 90%;\n  }\n\n  .drawer.drawer_close ~ .bodypage.nonnps {\n    width: 94.5% !important;\n    height: 100%;\n  }\n\n  .drawer.drawer_open ~ .bodypage.nonnps {\n    width: calc(96.5% - 217px);\n    height: 100%;\n  }\n}\n\n.gridData .gridContainer .MuiDataGrid-root .MuiDataGrid-footerContainer {\n  background-color: var(--whiteColour);\n}\n\n/* ── preCaseAllocation page tokens ──────────────────────────── */\nbody {\n  --pa-page-padding: 32px 24px;\n  --pa-icon-size: 18px;\n  --pa-hover-overlay: rgba(0, 0, 0, 0.06);\n  --pa-selection-bg-color: #f0f8fb;\n  --pa-selection-border-color: rgba(50, 118, 207, 0.25);\n  --pa-btn-hover-bg: rgba(50, 118, 207, 0.06);\n  --pa-assign-container-width: 500px;\n  --pa-warning-bg-color: #fff8e1;\n  --pa-warning-border-color: #ffb300;\n  --pa-warning-icon-color: #f57c00;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
